export default "__VITE_ASSET__DaOB5OAu__"